export default {
  endpointUrl: "https://apis.svc.engie-solutions.fr/techhelp/api/v1",
  redirectUrl: "https://techhelp.engie-solutions.fr/sso/oidc/login_redirect",
  oktaIssuer: "https://engie.okta-emea.com",
  oktaClientId: "0oagj93sb5htP8Mul0i7",
  enableOktaAuth: true,
};
